export {};

/*
 * По клику на шапку аккордеона надо переключить ему класс active, а body переключить slideDown/Up.
 */
const $window = $(window);

$(document).ready(
    function () {
        var accordionList = $('.accordion-list.accordion-list-opened');
        if (accordionList.length) {
            accordionList.find('.accordion').eq(0).find('.accordion__header').click();
        }

    }
);

$(document).on('click', '.accordion__header', function onClick(evt) {
    const $accordion = $(evt.currentTarget).closest('.accordion');
    const $accordionBody = $accordion.find('.accordion__body');
    const $sliders = $accordionBody.find('.titled-slider__list');

    if ($accordion.hasClass('active')) {
        $accordion.removeClass('active');
        $accordionBody.slideUp();
    } else {
        const $container = $accordion.find('.js-adaptive-bg');

        if (!!$container.length) {
            NLMK.adaptiveBackgrounds($container);
        }

        triggerAccordionShowed($sliders);
        $accordion.addClass('active');

        $accordionBody.slideDown();
    }
});

function triggerAccordionShowed($sliders) {
    $sliders.css('opacity', '0');
    $('body').trigger('accordion:showed', [$sliders]);
}



// WEBPACK FOOTER //
// ./js/main/module/accordion.js